// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"LoadingSpinner_spinnerWrapper__Ksn4R","spinnerWrapperSmall":"LoadingSpinner_spinnerWrapperSmall__1Ebc7"};